export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    requirePers() {
      return this.$store.state.settings.profile_pers === true && !this.$store.state.user.pers_at;
    },
    epsOrders() {
      return this.$store.state.eps.orders;
    },
    cards() {
      return this.$store.state.eps.cards;
    },
    payments() {
      return this.$store.state.payments.payments;
    },
    paymentsInfo() {
      return this.$store.state.paymentsInfo;
    },
    hasEps() {
      return this.$store.state.settings.eps === true;
    },
    hasPayments() {
      return this.$store.state.settings.payments === true;
    },
    hasShop() {
      return this.$store.state.settings.shop === true;
    },
  },
  mounted() {
    const app = this;
    if (app.hasEps) {
      app.$store.dispatch('eps/GetOrders', this.user.profile_id);
      app.$store.dispatch('payments/GetPayments', this.user.profile_id);
      app.$store.dispatch('GetPaymentsSettings');
    }
    if (app.requirePers) {
      app.$router.push('/dashboard', () => {
        setTimeout(() => {
          app.$store.dispatch('ShowError', 'Для раздела "Заказы" необходимо согласие на обработку персональных данных!');
        }, 500);
      });
    }
  },
  methods: {
    DownloadCard(order, card) {
      this.$store.dispatch('DownloadFile', {
        url: '/catalog/api-v3/cards/download-blob',
        data: {
          profile_id: this.user.profile_id,
          ms_order_id: order.ms_order_id,
          ms_card_id: card.ms_card_id,
        },
        filename: `${card.type}_${card.nominal}.pdf`,
      });
    },
    getPaymentByType(type) {
      const arr = this.paymentsInfo.methods.filter(item => item.type === type);
      return arr[0];
    },
    getPaymentIcon(type) {
      switch (type) {
        case 'phone':
          return 'local_phone';
        case 'yandex':
          return 'monetization_on';
        case 'webmoney':
          return 'attach_money';
        case 'qiwi':
          return 'account_balance_wallet';
        case 'card':
          return 'credit_card';
        case 'rbs':
          return 'account_balance';
        default:
          return 'account_balance_wallet';
      }
    },
    getPrizeByID(type) {
      const arr = this.cards.filter(item => item.type === type);
      return arr[0] || false;
    },
  },
};
